export type SiteLang = 'vi' | 'en';

export const APP_STORE_URL = 'https://apps.apple.com/vn/app/fconnect-htp/id6752923786?l=vi';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.taichinhhtp.fconnect&pcampaignid=web_share';

type NavItem = { to: string; label: string };

type SiteCopy = {
  home: string;
  nav: NavItem[];
  footerExtra: NavItem[];
  langSwitch: NavItem;
  menuOpen: string;
  menuClose: string;
  downloadCta: string;
  backToTop: string;
  company: string;
  contact: { label: string; value: string; href?: string }[];
  copyright: string;
  developedBy: string;
};

export const SITE_COPY: Record<SiteLang, SiteCopy> = {
  vi: {
    home: '/',
    nav: [
      { to: '/', label: 'Trang chủ' },
      { to: '/lao-dong-pho-thong', label: 'Lao động phổ thông' },
      { to: '/lao-dong-nong-nghiep', label: 'Lao động nông nghiệp' },
      { to: '/dich-vu-y-te', label: 'Dịch vụ y tế' },
      { to: '/privacy', label: 'Chính sách bảo mật' },
      { to: '/terms', label: 'Điều khoản' },
      { to: '/contact', label: 'Liên hệ' },
    ],
    footerExtra: [{ to: '/delete-account', label: 'Xóa tài khoản' }],
    langSwitch: { to: '/en', label: 'English' },
    menuOpen: 'Mở menu',
    menuClose: 'Đóng menu',
    downloadCta: 'Tải app',
    backToTop: 'Lên đầu trang',
    company: 'CÔNG TY CỔ PHẦN TÀI CHÍNH HIỆP TÍN PHÁT',
    contact: [
      { label: 'Email', value: 'trile@fconnect.vn', href: 'mailto:trile@fconnect.vn' },
      { label: 'Điện thoại', value: '02513684266', href: 'tel:02513684266' },
      {
        label: 'Địa chỉ',
        value: '11/4C, tổ 15, Kp 6, đường Nguyễn Ái Quốc, Phường Trấn Biên, Tp. Đồng Nai, Việt Nam',
      },
      { label: 'Thời gian hỗ trợ', value: '8:00 - 22:00 (Thứ 2 - Chủ nhật)' },
    ],
    copyright: '© 2025 Fconnect. Tất cả các quyền được bảo lưu.',
    developedBy: 'Phát triển bởi',
  },
  en: {
    home: '/en',
    nav: [
      { to: '/en', label: 'Home' },
      { to: '/en/general-labor', label: 'General labor' },
      { to: '/en/agricultural-labor', label: 'Agricultural labor' },
      { to: '/en/healthcare-services', label: 'Healthcare services' },
      { to: '/en/privacy', label: 'Privacy Policy' },
      { to: '/en/terms', label: 'Terms' },
      { to: '/en/contact', label: 'Contact' },
    ],
    footerExtra: [{ to: '/en/delete-account', label: 'Delete account' }],
    langSwitch: { to: '/', label: 'Tiếng Việt' },
    menuOpen: 'Open menu',
    menuClose: 'Close menu',
    downloadCta: 'Download app',
    backToTop: 'Back to top',
    company: 'HIEP TIN PHAT FINANCE JOINT STOCK COMPANY',
    contact: [
      { label: 'Email', value: 'trile@fconnect.vn', href: 'mailto:trile@fconnect.vn' },
      { label: 'Phone', value: '02513684266', href: 'tel:02513684266' },
      {
        label: 'Address',
        value: '11/4C, To 15, Kp 6, Nguyen Ai Quoc Street, Tran Bien Ward, Dong Nai City, Vietnam',
      },
      { label: 'Support hours', value: '8:00 - 22:00 (Mon - Sun)' },
    ],
    copyright: '© 2025 Fconnect. All rights reserved.',
    developedBy: 'Website developed by',
  },
};
